<template>
  <div class="z2-info-storage analysis-wrapper">
    <!-- Header -->
    <div class="analysis-header">
      <span>✨ PHÂN TÍCH HỘI THOẠI</span>
      <!-- <button class="btn-close">×</button> -->
      <div class="pointer" @click="$emit('close');">
        <IconV2 name="v2-arrow2_left" size="24px" />
      </div>
    </div>

    <div class="analysis-body">
      <!-- Progress (fake theo mức độ đầy đủ data) -->
      <!-- <section>
        <h4>📊 TIẾN ĐỘ PHÂN TÍCH</h4>
        <div class="progress-box">
          <span>Đã hoàn thành</span>
          <span>{{ progress }}%</span>
        </div>
        <div class="progress-bar">
          <div class="progress-fill" :style="{ width: progress + '%' }"></div>
        </div>
      </section> -->

      <!-- Scores -->
      <div>
        <button v-if="!isPolling"
          class="sw-btn-ptm"
          :class="btnClass"
          @click="handleAnalysisNew"
        >
          <!-- idle -->
          <template>
            <svg width="15" height="15" viewBox="0 0 24 24" fill="white">
              <path d="M12 2L9.5 9.5L2 12L9.5 14.5L12 22L14.5 14.5L22 12L14.5 9.5L12 2Z"/>
            </svg>
            <span>Phân tích mới</span>
            <span class="sw-ptm-badge">AI</span>
          </template>
        </button>
        <!-- <el-button v-if="!isPolling" size="large" class="p-1 mb-1" type="primary" @click="handleAnalysisNew">Phân tích mới</el-button> -->
        <div v-else class="logo-container-sm d-flex">
          <IconV2 name="el-icon-loading"></IconV2>
          <div class="ms-1">Đang phân tích dữ liệu</div>
        </div>
      </div>
      <p
        v-if="lastUpdateFormatted.length > 0"
        class="mb-2 text-nowrap text-muted" style="margin-top: 3px"
      >
        Cập nhật lần cuối: {{ lastUpdateFormatted }}
      </p>
      <section>
        <h4>⭐ ĐIỂM SỐ CHÍNH</h4>

        <div class="card">
          <div class="row">
            <span>Mức độ hài lòng</span>
            <strong>{{ data.satisfactionScore }}/10</strong>
          </div>
          <div class="stars">
            {{ renderStars(data.satisfactionScore) }}
          </div>
        </div>

        <div class="card">
          <div class="row">
            <span>Chất lượng chăm sóc</span>
            <strong>{{ data.careQualityScore }}/10</strong>
          </div>
          <div class="stars">
            {{ renderStars(data.careQualityScore) }}
          </div>
        </div>

        <div class="card">
          <div class="row">
            <span>Tốc độ quyết định</span>
            <strong>{{ data.decisionSpeed }}/10</strong>
          </div>
          <div class="stars">
            {{ renderStars(data.decisionSpeed) }}
          </div>
        </div>
      </section>

      <!-- Status -->
      <section>
        <h4>🎯 TRẠNG THÁI HỘI THOẠI</h4>
        <span class="tag warning">🟡 {{ data.status }}</span>
        <span
          class="tag"
          :class="sentimentClass"
        >
          {{ sentimentIcon }} {{ data.noteSentiment }}
        </span>
      </section>

      <!-- Category -->
      <section>
        <h4>📁 VẤN ĐỀ GẶP PHẢI</h4>
        <div class="box">{{ getProblemCategory(data.problemCategory) }}</div>
      </section>

      <!-- Summary -->
      <section>
        <h4>📝 TÓM TẮT NỘI DUNG</h4>
        <div class="box">{{ data.summaryContent }}</div>
      </section>

      <!-- Objection -->
      <section>
        <h4>⚠️ LÝ DO TỪ CHỐI / DO DỰ</h4>
        <div class="box">{{ data.objectionTypes }}</div>
      </section>

      <!-- Keywords -->
      <section>
        <h4>🔍 TỪ KHÓA QUAN TRỌNG</h4>
        <div class="chips">
          <span
            v-for="k in keywordList"
            :key="k"
          >
            {{ k }}
          </span>
        </div>
      </section>

      <!-- Tags -->
      <section>
        <h4>🏷️ TAG AI (gợi ý)</h4>
        <div class="chips tag-chips">
          <span v-for="(t,index) in tagParse" :key="index">{{ t }}</span>
        </div>
      </section>

      <!-- Next action -->
      <section>
        <h4>📌 GỢI Ý TIẾP THEO</h4>
        <div class="box highlight">
          {{ data.nextActionSuggestion }}
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: "ConversationAnalysis",
  props: {
    data: {
      type: Object,
      required: true
    },
    dataLastest: {
      type: Object,
      required: true
    },
    lastMessageTime: {
      type: Number
    }
  },
  data() {
    return {
      isPolling: false
    }
  },
  computed: {
    btnClass () {
      return 'sw-btn-ptm--idle'
    },
    showAnalysisIcon() {
      if (!this.data?.createAt) return false;

      const createdTime = new Date(this.data.createAt).getTime();
      const now = Date.now();

      const diffInMs = now - createdTime;

      const oneHour = 60 * 60 * 1000;

      return diffInMs >= oneHour;
    },
    tagParse() {
      try {const parsed = JSON.parse(this.data.tags)
        return Array.isArray(parsed) ? parsed : []
      } catch (e) {
        return []
      }
    },
    keywordList() {
      if (!this.data.noteKeywords) return [];
      try {
        return JSON.parse(this.data.noteKeywords);
      } catch (e) {
        return this.data.noteKeywords.split(",").map(k => k.trim());
      }
    },
    sentimentClass() {
      return this.data.noteSentiment === "TIÊU CỰC"
        ? "danger"
        : "success";
    },
    sentimentIcon() {
      return this.data.noteSentiment === "TIÊU CỰC" ? "😟" : "😊";
    },
    progress() {
      // giả lập % dựa trên số field có data
      let filled = Object.values(this.data).filter(v => v).length;
      return Math.min(100, Math.round((filled / 15) * 100));
    },
    lastUpdateFormatted() {
      const ts = this.data?.createAt
      if (!ts) return ''

      const d = new Date(ts)
      return d.toLocaleString('vi-VN', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      })
    }
  },
  methods: {
    getProblemCategory(data) {
      if (!data) return '';
      try {
        const arr = JSON.parse(data);
        if (Array.isArray(arr)) return arr.join('\n');
      } catch (e) {
        console.log(e);
      }

      const parts = data.split(':');
      return parts.length > 1 ? parts.slice(1).join(':').trim() : data;
    },
    handleAnalysisNew() {
      const now = Date.now()

      const lastMsgTime = Number(this.lastMessageTime)
      const createdAt = Number(this.data?.createAt)
      if (!lastMsgTime) {
        this.$message.error("Không đủ dữ liệu để phân tích.");
        return;
      }

      const before24h = now - 24 * 60 * 60 * 1000

      if (lastMsgTime < before24h) {
        this.$message.error("Chưa phát sinh tin nhắn 1 ngày gần nhất.");
        return;
      }

      if (lastMsgTime < createdAt || lastMsgTime > now) {
        this.$message.error("Chưa phát sinh tin nhắn kể từ lần phân tích cuối.");
        return;
      }
      if (!this.showAnalysisIcon) {
        this.$message.error("Bạn đã phân tích hội thoại này trong khoảng 1 tiếng gần đây. Vui lòng thử lại sau.");
        return;
      }
      this.isPolling = true;
      this.$bus.$emit('analysisNew');
    },
    renderStars(score) {
      return "★".repeat(score) + "☆".repeat(10 - score);
    }
  },
  mounted() {
    this.$bus.$on('analysisNewDone', () => {
      this.isPolling = false;
    });
    this.isPolling = this.dataLastest.analysisStatus == 'PROCESSING' ? true : false;
  },
  beforeDestroy() {
    this.$bus.$off('analysisNewDone');
  }
};
</script>

<style scoped>
.analysis-wrapper {
  width: 380px;
  /* border-radius: 12px; */
  overflow: hidden;
  background: #f7f9fc;
  font-family: system-ui, -apple-system;
  max-height: calc(100vh);
  overflow-y: auto;
}

.analysis-header {
  background: linear-gradient(90deg, #4facfe, #7f5cff);
  color: #fff;
  padding: 23px 16px;
  display: flex;
  justify-content: space-between;
  font-weight: 600;
}

.btn-close {
  background: rgba(255,255,255,.2);
  border: none;
  color: #fff;
  font-size: 18px;
  width: 28px;
  height: 28px;
  border-radius: 8px;
}

.analysis-body {
  padding: 14px;
}

section {
  margin-bottom: 16px;
}

h4 {
  font-size: 13px;
  margin-bottom: 8px;
}

.progress-box {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
}

.progress-bar {
  background: #e5e7eb;
  border-radius: 8px;
  height: 8px;
  margin-top: 6px;
}

.progress-fill {
  height: 100%;
  border-radius: 8px;
  background: linear-gradient(90deg, #4facfe, #7f5cff);
}

.card {
  background: #fff;
  border-radius: 10px;
  padding: 10px;
  margin-bottom: 8px;
}

.row {
  display: flex;
  justify-content: space-between;
}

.stars {
  color: #f5b301;
  font-size: 14px;
}

.tag {
  display: inline-block;
  padding: 6px 10px;
  border-radius: 20px;
  font-size: 12px;
  margin-right: 6px;
}

.warning {
  background: #fde68a;
  color: #92400e;
}

.success {
  background: #bbf7d0;
  color: #166534;
}

.danger {
  background: #fecaca;
  color: #7f1d1d;
}

.box {
  background: #fff;
  border-radius: 10px;
  padding: 10px;
  font-size: 13px;
  white-space: pre-line;
}

.highlight {
  background: #ecfeff;
  border: 1px solid #67e8f9;
}

.chips span {
  background: #e0f2fe;
  color: #0369a1;
  padding: 6px 10px;
  border-radius: 20px;
  font-size: 12px;
  margin: 4px 4px 0 0;
  display: inline-block;
}

.tag-chips span {
  background: #ede9fe;
  color: #5b21b6;
}

.z2-info-storage {
  position: absolute;
  width: 300px;
  height: 100vh;
  top: 0;
  z-index: 3000;
  /* background-color: white; */
}

.sw-btn-ptm {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  padding: 11px 16px;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  font-size: 13.5px;
  font-weight: 700;
  color: #fff;
  letter-spacing: 0.3px;
  position: relative;
  overflow: hidden;
  transition: transform 0.15s ease, box-shadow 0.2s ease;
}

/* Shine sweep pseudo-element */
.sw-btn-ptm::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 60%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.18), transparent);
  transform: skewX(-20deg);
  transition: left 0.5s ease;
}
.sw-btn-ptm:hover::before { left: 150%; }

/* ── State: IDLE ─────────────────────────────────────────── */
.sw-btn-ptm--idle {
  background: linear-gradient(270deg, #4f63d2, #8b5cf6, #6366f1, #7c3aed);
  background-size: 300% 300%;
  animation: sw-shimmer 5s ease infinite;
  box-shadow: 0 4px 16px rgba(99,102,241,0.45), inset 0 1px 0 rgba(255,255,255,0.15);
}
.sw-btn-ptm--idle:hover {
  transform: translateY(-2px);
  box-shadow: 0 7px 22px rgba(99,102,241,0.55), inset 0 1px 0 rgba(255,255,255,0.2);
}
.sw-btn-ptm--idle:active {
  transform: translateY(0);
  box-shadow: 0 2px 8px rgba(99,102,241,0.3);
}
.sw-btn-wrap {
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

.sw-ptm-badge {
  font-size: 10px;
  font-weight: 800;
  background: rgba(255,255,255,0.2);
  border: 1px solid rgba(255,255,255,0.3);
  border-radius: 4px;
  padding: 1px 6px;
  letter-spacing: 1px;
}
</style>
